module.exports = "/_next/static/images/web3-banner-mobile-886b9c0b30e9659a0cdf053db01214ee.webp";